// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const paymentApproval = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/payment-approval/payment-approval.store.js